import { render, staticRenderFns } from "./UpdateAddressInput.vue?vue&type=template&id=502a925c"
import script from "./UpdateAddressInput.vue?vue&type=script&lang=js"
export * from "./UpdateAddressInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports